import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Heading, Layout } from '@americanexpress/dls-react';
import { CommonTable } from '../CommonTable';
import ShowPWBT from '../ShowPWBT';
import { PERMISSIONS_COLUMNS, PERMISSIONS_PAGE } from '../../copyText/permissionsPage';

function PermissionsPage({ consentPayload, onOpenCancelDialog, isDeletePendingInSession = false }) {
  const dispatch = useDispatch();
  const consentDetails = consentPayload?.vrp_consent_details || {};

  const deletePendingPermissions = consentDetails.DELETE_PENDING ?? [];
  const activePermissions = [
    ...consentDetails.ACTIVE ?? [],
    ...(deletePendingPermissions ?? /* istanbul ignore next */ []).map((row) => ({
      ...row,
      status: 'DELETE_PENDING',
    })),
  ];
  const expiredPermissions = consentDetails.EXPIRED ?? [];
  const cancelledPermissions = consentDetails.CANCELLED ?? [];

  const isDeletePending = isDeletePendingInSession || deletePendingPermissions.length > 0;

  const inactiveColumns = [
    ...PERMISSIONS_COLUMNS.ACTIVE_PERMISSIONS_COLUMNS,
    ...PERMISSIONS_COLUMNS.INACTIVE_PERMISSIONS_COLUMNS,
  ];
  const activeColumns = PERMISSIONS_COLUMNS.ACTIVE_PERMISSIONS_COLUMNS;

  const inactivePermissions = [
    ...(expiredPermissions || /* istanbul ignore next */ []).map((row) => ({
      ...row,
      status: 'INACTIVE',
    })),
    ...(cancelledPermissions || /* istanbul ignore next */ []).map((row) => ({
      ...row,
      status: 'CANCELLED',
    })),
  ];

  return (
    <>
      <Layout innerContainerClassName="pad-4" variant="card">
        <Heading level={2} variant="sans-small-bold" className="margin-2-b">
          {PERMISSIONS_PAGE.ACTIVE_PERMISSIONS}
        </Heading>
        <CommonTable
          tableID="active-permissions-table"
          columns={activeColumns}
          data={activePermissions}
          emptyContent={(
            <div className="flex flex-column flex-align-items-center pad-2">
              <Heading level={3} variant="sans-xsmall-bold">{PERMISSIONS_PAGE.ACTIVE_PERMISSIONS}</Heading>
              <p>{PERMISSIONS_PAGE.NO_ACTIVE_PERMISSIONS.P1}</p>
              <p className="margin-2-b">{PERMISSIONS_PAGE.NO_ACTIVE_PERMISSIONS.P2}</p>
              <ShowPWBT amexPaywithbank={consentPayload} action="create" dispatch={dispatch} />
            </div>
          )}
        />
        {isDeletePending && (
          <p
            role="status"
            aria-live="polite"
            style={{ color: '#c20f2f', marginTop: '12px', marginBottom: 0 }}
          >
            Cancellation request in progress of the above VRP consent
          </p>
        )}

        {activePermissions.length > 0 && !isDeletePending && (
          <div className="flex flex-justify-end margin-2-t">
            <ShowPWBT amexPaywithbank={consentPayload} action="edit" dispatch={dispatch} />
            <Button
              className="margin-2-l"
              variant="secondary"
              onClick={() => {
                const deletablePermission = activePermissions?.find(
                  (permission) => String(permission?.status ?? '').toUpperCase() !== 'DELETE_PENDING'
                );
                if (deletablePermission) {
                  onOpenCancelDialog(deletablePermission);
                }
              }}
            >
              {PERMISSIONS_PAGE.CANCEL_PERMISSION}
            </Button>
          </div>
        )}
      </Layout>

      <Layout innerContainerClassName="pad-4 margin-4-t" variant="card">
        <Heading level={2} variant="sans-small-bold" className="margin-2-b">
          {PERMISSIONS_PAGE.INACTIVE_PERMISSIONS}
        </Heading>
        <CommonTable
          tableID="inactive-permissions-table"
          columns={inactiveColumns}
          data={inactivePermissions}
          emptyContent={(
            <div className="flex flex-column flex-align-items-center pad-2">
              <Heading level={3} variant="sans-xsmall-bold">{PERMISSIONS_PAGE.INACTIVE_PERMISSIONS}</Heading>
              <p>{PERMISSIONS_PAGE.NO_ACTIVE_PERMISSIONS.P1}</p>
            </div>
          )}
        />
      </Layout>
    </>
  );
}

export default PermissionsPage;
